module.exports = __webpack_public_path__ + "static/media/tile-backer-9slice.58b3c0fc.png";